const MetaDataPoolList = () => import('Views/metaDataPool/metaDataPool-list-new-ui');
const MetaDataPoolAdultList = () => import('Views/metaDataPool/metaDataPoolAdult-list-new-ui');
const MetaDataPoolDetail = () => import('Views/metaDataPool/metaDataPool-detail-new-ui');
const MetaDataPoolAddEdit = () => import('Views/metaDataPool/metaDataPool-addEdit-new-ui');
const MetaDataPoolEntity = () => import('Views/metaDataPool/metaDataPool-entity-new-ui');

export default[
  { path: '/metaDataPool-list', component: MetaDataPoolList },
  { path: '/metaDataPoolAdult-list', component: MetaDataPoolAdultList },
  { path: '/metaDataPool-detail/:id', component: MetaDataPoolDetail },
  { path: '/metaDataPool-add', component: MetaDataPoolAddEdit },
  { path: '/metaDataPool-edit/:id', component: MetaDataPoolAddEdit },
  { path: '/metaDataPool-entity/:id', component: MetaDataPoolEntity },
];



// WEBPACK FOOTER //
// ./src/router/metaDataPool.js